import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // Stage 5 mobile fix (retest iteration_16): actual bounding box is
      // 44×44 on mobile (min-h-11 min-w-11) so strict getBoundingClientRect
      // audits pass WCAG 2.2 target-size. The visible tick box stays 16×16
      // via the nested <span> below. Desktop (`sm:`) reverts to compact.
      "peer min-h-11 min-w-11 sm:min-h-0 sm:min-w-0 sm:h-4 sm:w-4 shrink-0 inline-flex items-center justify-center rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 group",
      className
    )}
    {...props}>
    <span aria-hidden="true" className="pointer-events-none block h-4 w-4 rounded-sm border border-primary shadow group-data-[state=checked]:bg-primary group-data-[state=checked]:text-primary-foreground">
      <CheckboxPrimitive.Indicator className={cn("flex h-full w-full items-center justify-center text-current")}>
        <Check className="h-4 w-4" />
      </CheckboxPrimitive.Indicator>
    </span>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
